/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-20 10:44:54
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-06 15:07:35
 * @FilePath: /dbrank_b/src/routes/visualChart/components/TooltipDrawer/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from './index.css';
import classNames from 'classnames';

class Button extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    children: PropTypes.node.isRequired,
    propsRef: PropTypes.func
  }

  setRef = (ref) => {
    const { propsRef } = this.props;
    propsRef && propsRef(ref)
  }

  render () {
    // eslint-disable-next-line no-unused-vars
    const { children, type, propsRef, ...props } = this.props;

    return <button {...props} ref={this.setRef} className={classNames(s.btn, s[type])}>{children}</button>
  }
}

export default withStyles(s)(Button);



// WEBPACK FOOTER //
// src/routes/visualChart/components/Button/index.js